export const playIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="7px" height="13px">
    <path
      fillRule="evenodd"
      fill="rgb(255, 255, 255)"
      d="M0.006,0.693 L6.963,6.646 L0.006,12.599 L0.006,0.693 Z"
    />
  </svg>
);
